import React from "react";

import { Select } from "src/base-components/Select";
import { ProviderSdkConfigResponse } from "src/clients/sdk";
import { buildSdkScriptOptions } from "src/connections/sdk/scriptOptions";

type Props = {
  dataLoc: string;
  configs: ProviderSdkConfigResponse[];
  value: string[];
  onChange: (value: string[]) => void;
};

/**
 * Multi-select of SDK Scripts for bundle forms. Each option shows the provider
 * logo and provider version; scripts that would break the
 * one-script-per-provider-version rule against the current selection are
 * disabled with the reason as tooltip.
 */
export const SdkScriptSelect: React.FC<Props> = ({
  dataLoc,
  configs,
  value,
  onChange,
}) => (
  <Select
    dataLoc={dataLoc}
    options={buildSdkScriptOptions(configs, value)}
    placeholder="Select SDK Scripts"
    value={value}
    fullWidth
    multiple
    searchable
    onChange={onChange}
  />
);
